import { render } from "./Practicantes.vue?vue&type=template&id=35099ac2"
import script from "./Practicantes.vue?vue&type=script&lang=js"
export * from "./Practicantes.vue?vue&type=script&lang=js"

import "./Practicantes.vue?vue&type=style&index=0&id=35099ac2&lang=scss&scope=true"
script.render = render

export default script